import EmailWidget from './email-widget';
import TextWidget from './text-widget';
import SelectWidget from './select-widget';

export default {
  EmailWidget,
  TextWidget,
  SelectWidget
};



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/widgets/index.js